import { Auth } from 'aws-amplify';
import React, { createContext, FC, ReactNode, useState } from 'react';

type Nullable<T> = T | null;

export interface AuthContextProps {
  authToken: Nullable<string>;
  updateAuthToken: () => Promise<boolean>;
}

interface AuthProviderProps {
  children: ReactNode;
}

/* eslint-disable */
const defaultProps: AuthContextProps = {
  authToken: null,
  updateAuthToken: async () => false,
};
/* eslint-enable */

const AuthContext = createContext<AuthContextProps>(defaultProps);

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
  const [authToken, setAuthToken] = useState<Nullable<string>>(null);

  const updateAuthToken = async (): Promise<boolean> => {
    try {
      const token = (await Auth.currentSession()).getIdToken().getJwtToken();
      setAuthToken(token);
      return true;
    } catch (err: any) {
      if (err !== 'No current user') {
        alert(err);
        console.error({
          message: 'Error while updating auth token',
          error: err?.stack || err,
        });
      }
      setAuthToken(null);
    }
    return false;
  };

  return (
    <AuthContext.Provider
      value={{
        authToken,
        updateAuthToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext: () => AuthContextProps = () => {
  return React.useContext(AuthContext);
};
